"use client";

import { withFallback } from "../with-fallback";

export const AddPayoutMethodElement = withFallback({
	displayName: "AddPayoutMethodElement",
	type: "add-payout-method-element",
} as const);
